import { VatZoneType } from "types/VatZoneType";
import { FetchError } from "util/exceptions";
import { API_URL } from "./common";

export const getVatZones = (token: string): Promise<VatZoneType[]> => {
    return fetch(`${API_URL}/v1/ecommerce/vat-zones`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to fetch VAT zones', response.status);
        }
        return response.json();
    });
};
